import { useNavigate, Link } from "react-router-dom";
import { ArrowBigLeft } from "lucide-react";
import './Navbar.css';


function Navbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    window.location.href = "/login";
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="hamburger" onClick={() => navigate('/quaythuong')}>
          <ArrowBigLeft size={28} />
        </button>
        <h6 className="logo">Nhấn để về trang Quay Thưởng</h6>

        <button onClick={handleLogout} className="bg-red-500 text-white p-2 rounded" style={{marginLeft: '20px'}}>
          Đăng xuất
        </button>
      </div>
      <li><Link style={{color:'white', marginRight: 20}} to="/nguoitrungthuong">Danh sách người trúng</Link></li>
      <li><Link style={{color:'white', marginRight: 20}} to="/giaithuong">Quản lý giải thưởng</Link></li>
      <li><Link style={{color:'white', marginRight: 20}} to="/caidat-nen">Cài đặt hình nền</Link></li>
    </nav>
  );
}

export default Navbar;
